import { action, observable } from 'mobx';
import StrapiHelper from '../services/StrapiHelper.service';
declare var grecaptcha: any;

export default class CodeInputStore {
  @observable
  loading: boolean = false;

  userStore: any;
  @observable
  isInEdit: boolean = false;
  @observable
  current: any = -1;
  @observable
  code: string[] = ['', '', '', '', '', '', '', '', ''];
  @observable
  codeLength: any = 8;
  @observable
  done: boolean = false;
  @observable
  collectedPoints: any = 0;
  @observable
  startPoints: any = 0;
  @observable
  codeWrong: boolean = false;
  @observable
  mapOpen: boolean = false;
  @observable
  mapError: any = '';
  @observable
  cords: any = {};
  @observable
  resendWithCords: boolean = false;
  @observable
  geolocationEnabled: boolean = false;
  @observable
  codeModalOpen: boolean = false;
  @observable
  currAddedGoalsStatus: any = '';
  @observable
  currAddedGoalsAnimation: boolean = false;
  @observable
  currPickupWon: any = null;

  @action
  addUserStore(store: any) {
    this.userStore = store;
  }

  @action
  getNewIndex(code: any) {
    for (let i = 0; i < code.length; i++) {
      if (code[i] == '') {
        return i;
      }
    }
    return code.length;
  }

  @action
  checkDone(code: any) {
    for (let i = 0; i < code.length; i++) {
      if (code[i] == '') {
        return false;
      }
    }
    return true;
  }

  @action
  appendCode(codeInput: any, index: any) {
    let code = this.code;
    let input = codeInput.toUpperCase();
    code[index] = input;
    this.code = code;
    this.current = this.getNewIndex(code);
    this.done = this.checkDone(code);
  }

  @action
  removeCodeSnipped() {
    let code = this.code;
    let current = this.current - 1;
    if (current < 0) {
      current = 0;
    }
    code[current] = '';

    this.code = code;
    this.current = current;
    this.done = this.checkDone(code);
  }

  @action
  codeFocus(index: any) {
    let code = this.code;
    code[index] = '';

    this.current = index;
    this.code = code;
    this.done = this.checkDone(code);
  }

  @action
  clearCode() {
    this.code = ['', '', '', '', '', '', '', '', ''];
    this.done = false;
  }

  @action
  startSendCode() {
    this.loading = true;
  }

  @action
  stopSendCode() {
    this.loading = false;
  }

  @action
  setStartPoints(startPoints: any) {
    this.startPoints = startPoints;
  }

  @action
  redeemCodeError() {
    this.codeWrong = true;
  }

  @action
  setCurrentCodeIndex(index: any) {
    this.current = index;
  }

  @action
  clearRedeemCodeError() {
    this.codeWrong = false;
    this.done = false;
  }

  @action
  displayMap(open: boolean) {
    this.mapOpen = open;
  }

  @action
  setMapError(error: any) {
    this.mapError = error;
  }

  @action
  setCords(cords: any) {
    this.cords = cords;
  }

  @action
  setResendWithCords(resendWithCords: boolean) {
    this.resendWithCords = resendWithCords;
  }

  @action
  setGeolocationEnabled(enabled: boolean) {
    this.geolocationEnabled = enabled;
  }

  @action
  openCodeInput() {
    this.collectedPoints = 0;
    this.codeModalOpen = true;
  }

  @action
  closeCodeInput() {
    this.codeModalOpen = false;
  }

  @action
  collectedPointsAdded(points: Number) {
    this.collectedPoints = this.collectedPoints + points;
  }

  @action
  currGoalsAdded(goalStatus: any) {
    this.currAddedGoalsAnimation = true;
    this.currAddedGoalsStatus = goalStatus;
  }

  @action
  clearCurrGoalsAdded() {
    this.currAddedGoalsStatus = '';
    this.currAddedGoalsAnimation = false;
  }

  @action
  setCurrPickupWon(pickup: any) {
    this.currAddedGoalsAnimation = true;
    this.currPickupWon = pickup;
  }

  @action
  clearCurrPickupWon() {
    this.currPickupWon = null;
  }

  @action
  sendCodeErrorHandling(error?: any) {
    if (error) {
      this.setMapError(error);
    } else {
      this.setMapError('code_incorrect');
    }
    this.stopSendCode();
    this.setCurrentCodeIndex(-1);
    this.redeemCodeError();
    this.setResendWithCords(false);
    setTimeout(() => {
      this.setMapError('');
      this.setCurrentCodeIndex(0);
      this.clearCode();
    }, 3500);
  }

  @action
  sendCodeResultHandling(result: any) {
    this.stopSendCode();
    if (result.data.pickup) {
      // Instant price — physical pickup.
      this.setCurrPickupWon(result.data.pickup);
    } else {
      // Every non-pickup successful code awards a point — show the Toooor!
      // celebration. The legacy `isGoal` field and random "Latte/Stange/..."
      // miss branch are not used in WM 2026: the backend doesn't send isGoal,
      // and no code here is a dud.
      const earned = Number(result.data.earnedPoints) || 1;
      if (
        typeof result.data.newPoints === 'number' &&
        this.userStore &&
        typeof this.userStore.addPoints === 'function'
      ) {
        this.userStore.addPoints(result.data.newPoints);
      }
      this.collectedPointsAdded(earned);
      this.currGoalsAdded('Toooor');
    }

    this.setMapError('no_error');
  }

  @action
  timeOutOver() {
    this.clearCode();
    this.clearCurrPickupWon();
    this.setCurrentCodeIndex(-1);
    this.setMapError('');
    this.clearCurrGoalsAdded();
  }

  @action
  sendCode(inputcode: any, location?: any) {
    var self = this;

    self.startSendCode();
    self.setResendWithCords(false);
    /**
     * Get the code.
     */
    let code = '';
    for (let i = 0; i < inputcode.length; i++) {
      code += inputcode[i];
    }

    // --- DEBUG codes (stripped from prod build by DefinePlugin) ---
    // Type these as the 9-char code to preview outcome UIs without backend.
    //   DEBUGPICK -> Sofortpreis / instant price won (pickup UI)
    //   DEBUGGOAL -> Toooor! goal celebration (+1 point)
    //
    // Enabled automatically on localhost (DEV mode).
    // On Vercel/Netlify branch previews set VITE_ENABLE_DEBUG_CODES=true
    // as a Preview-scoped env var — production builds without that var have
    // the whole branch dead-code-eliminated by Vite at build time.
    if (
      import.meta.env.DEV ||
      import.meta.env.VITE_ENABLE_DEBUG_CODES === 'true'
    ) {
      if (code === 'DEBUGPICK') {
        setTimeout(() => {
          self.sendCodeResultHandling({
            data: {
              pickup: {
                product: 'Mohren Spezial 6er Tray (Debug)',
                productPreview: {
                  formats: {
                    small: {
                      url:
                        'https://placehold.co/400x400/b40e0e/ffffff/png?text=Sofortpreis',
                    },
                  },
                },
              },
            },
          });
        }, 400);
        return;
      }
      if (code === 'DEBUGGOAL') {
        setTimeout(() => {
          self.sendCodeResultHandling({
            data: {
              earnedPoints: 1,
              newPoints: (self.userStore?.currentUser?.points || 0) + 1,
            },
          });
        }, 400);
        return;
      }
    }

    grecaptcha.ready(function () {
      grecaptcha
        .execute('6LdDNqEUAAAAABH82phBBZchoJO0rQXVJM-SXUpk', {
          action: 'code_send',
        })
        .then(function (token) {
          StrapiHelper.redeemCode(code)
            .then((result) => {
              return self.sendCodeResultHandling(result);
            })
            .catch((error) => {
              // Axios interceptor rejects with AppError; use .status (was error.response.status).
              return self.sendCodeErrorHandling(
                error?.status === 410 ? 'code_used' : ''
              );
            });
        })
        .catch(() => {
          return self.sendCodeErrorHandling();
        });
    });
  }
}
